import React from 'react';
import Popup from 'reactjs-popup';
import XMark from "../assets/icons/Xmark";
import './modalContent.css';

interface PopupWrapperInterface {
    isPopupOpen: boolean;
    setIsPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
    isNested: boolean;
}
const ModalContent = (props: PopupWrapperInterface) => {
    const handleClosePopup = () => { props.setIsPopupOpen(false) }

    return (
        <Popup open={props.isPopupOpen} onClose={handleClosePopup} className="popup-overlay" modal nested={props.isNested}>
                <div className="modal-container">
                    <div className="modal-header no-select">
                        <div className="header-text">
                            Scan your handwritten compositions
                        </div>
                        <div className="absolute top-[46px] right-[32px]">
                            <svg className="popup-close-button" onClick={handleClosePopup}></svg>
                        </div>
                    </div>
                    <div className="flex flex-auto">
                        <div className="modal-body">
                            <div className="text-['Museo'] text-[#262262] text-[16px] font-medium max-md:overflow-auto max-md:h-[70vh]">
                                <div className="font-bold mb-8">
                                    Want to use the Composition Checker on your handwritten ones from school? Just scan it with an OCR software - it’s easy!
                                </div>
                                <div className="font-medium mb-5">
                                    <b>Step #1:</b> Take a picture of your composition on paper. Make sure that the entire page is brightly lit and that the words can be clearly seen.
                                </div>
                                <div className="font-medium mb-0">
                                    <b>Step #2:</b> Use any free OCR application available online, such as the one from <a href="https://www.onlineocr.net/" className="underline" target="_blank" rel="noreferrer">OnlineOCR.net</a>, or directly on <a href="https://support.google.com/drive/answer/176692?hl=en&co=GENIE.Platform%3DDesktop&oco=1" className="underline" target="_blank" rel="noreferrer">Google Drive</a>.
                                </div>
                                <div className="font-medium mb-5">
                                    <b>Note:</b> Please stay vigilant while online and avoid clicking on suspicious links.
                                </div>
                                <div className="font-medium mb-5">
                                    <b>Step #3:</b> Follow the onscreen instructions by the OCR app of your choice to generate the text. Paste it in a text editor such as Microsoft Word or Google Docs.
                                </div>
                                <div className="font-medium mb-5">
                                    <b>Step #4:</b> Check the digital version of your composition and make sure that there are no mistakes. OCR apps can sometimes scan words wrongly and mistype them.
                                </div>
                                <div className="font-medium mb-3">
                                    <b>Step #5:</b> Paste the final text into Geniebook’s Composition Checker and get instant feedback!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </Popup>
    );
};

export default ModalContent;